var _circle, _circle2, _path, _ellipse, _ellipse2, _path2, _path3, _path4, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfile3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    transform: "rotate(90 26 26)",
    fill: "#5D69D7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6701,
    cy: 28.1307,
    r: 15.4027,
    fill: "#FFF3F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1603 29.0247C13.3458 28.5332 15.8642 27.7967 17.282 27.3591L20.6938 23.6243V26.88L31.4137 26.88V22.9624C32.2574 24.3519 33.6739 26.0433 34.6465 26.88C35.1821 27.3408 36.6175 27.8696 38.2798 28.482C39.4752 28.9224 40.7879 29.4061 41.9677 29.9387C42.0371 29.344 42.0728 28.7391 42.0728 28.1258C42.0728 19.5825 35.147 12.6567 26.6037 12.6567C18.0603 12.6567 11.1346 19.5825 11.1346 28.1258C11.1346 28.4276 11.1432 28.7273 11.1603 29.0247Z",
    fill: "#8E5D48"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.4211,
    cy: 31.318,
    rx: 1.06225,
    ry: 1.59338,
    fill: "#262626"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.9191,
    cy: 31.318,
    rx: 1.06225,
    ry: 1.59338,
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7946 35.0361H24.28C24.28 36.0984 25.0767 36.8951 26.6701 36.8951C28.1724 36.8951 28.7061 35.7443 28.7946 35.0361Z",
    fill: "#F09387"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2028 21.9933H11.7938C13.2452 15.2056 19.2774 10.1157 26.4983 10.1157C33.7193 10.1157 39.7514 15.2056 41.2028 21.9933Z",
    fill: "#FC8368"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 25.3635L12.1852 18.9916C22.4684 16.9526 35.717 18.142 41.1996 18.9916L42.8499 25.3635C33.5587 22.653 18.5547 23.1546 10.4 25.3635Z",
    fill: "#F47153"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.3191,
    cy: 11.5697,
    r: 2.65563,
    fill: "#FC8368"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile3);
export default __webpack_public_path__ + "static/media/img_profile_3.380c682a9294d7efbe9bf0239a4e9b7b.svg";
export { ForwardRef as ReactComponent };